function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 10px 0 20px;\n  display: flex;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 18px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 5px;\n  font-size: 14px;\n  font-weight: 800;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 12px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 10px;\n  font-size: 12px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: 5px;\n  cursor: pointer;\n  align-self: flex-start;\n\n  svg {\n    color: #333;\n    opacity: 0.4;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0 5px;\n  cursor: pointer;\n  height: 100%;\n  display: flex;\n  align-items: center;\n\n  ",
        "\n\n  svg {\n    color: #333;\n    opacity: 0.4;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
import React from "react";
import styled from "styled-components";
import formatCurrency from "../../../../utils/format-currency";
import { FaMinusCircle, FaArrowCircleDown, FaArrowCircleUp } from "react-icons/fa";
import { GiTwoCoins } from "react-icons/gi";
import { withContext } from "../../../wr-context";
import { getRowsSummary } from "../../../../modules/product/product-utils";
import { Row, Col } from "react-flexbox-grid";
import { CartProductActionType } from "../../../wr-context/default-ctx/actions";
var Product = styled.div(_templateObject(), function(props) {
    return props.hasQuantityEnabled ? "justify-content: space-between;" : null;
});
var ProductInfo = styled.div(_templateObject1());
var ProductName = styled.p(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.palette.primary;
});
var ProductPrice = styled.div(_templateObject3());
var ProductQuantityWrapper = styled.div(_templateObject4());
var ProductQuantity = styled.p(_templateObject5());
var ProductDescription = styled.p(_templateObject6());
// Make it accessible from outside so we can extend its styles
export var RemoveFromCart = styled.div(_templateObject7());
var UpdateCartQuantity = styled.div(_templateObject8(), function(props) {
    return props.canBeClicked ? "pointer-events: none; opacity: 0.3;" : null;
});
var defaultRenderProductSummary = function(product) {
    var rowsSummary = getRowsSummary(product.rows);
    return rowsSummary.map(function(row, i) {
        var values = Array.isArray(row.value) ? row.value.map(function(v) {
            return v.label || v;
        }) : [
            row.value
        ];
        return /*#__PURE__*/ React.createElement(Row, {
            key: i
        }, /*#__PURE__*/ React.createElement(Col, {
            xs: 12
        }, row.label, " - ", values.join(", ")));
    });
};
var CartProduct = function(props) {
    var product = props.product, price = props.price, renderPrice = props.renderPrice, context = props.context, priceValue = props.priceValue, hidePriceAndDurationIfZero = props.hidePriceAndDurationIfZero, renderName = props.renderName, // This is to allow re-styling this using styled
    className = props.className, _renderProductSummary = props.renderProductSummary, renderProductSummary = _renderProductSummary === void 0 ? defaultRenderProductSummary : _renderProductSummary;
    return /*#__PURE__*/ React.createElement(Product, {
        hasQuantityEnabled: context.constants.cart.enableQuantity,
        className: className
    }, /*#__PURE__*/ React.createElement(ProductInfo, null, /*#__PURE__*/ React.createElement(RemoveFromCart, {
        onClick: function() {
            return context.actions.removeProductFromCart(product.id, product);
        }
    }, /*#__PURE__*/ React.createElement(FaMinusCircle, null)), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(ProductName, {
        className: "cart-product-name"
    }, renderName({
        props: props,
        defaultRender: function() {
            return product.name;
        }
    })), /*#__PURE__*/ React.createElement(ProductPrice, {
        className: "cart-product-price"
    }, renderPrice({
        props: props,
        defaultRender: function(children) {
            return children || (priceValue || !hidePriceAndDurationIfZero) && (context.state.pointSystem ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(GiTwoCoins, {
                size: 20
            }), " ", price) : formatCurrency(Number(price)));
        }
    })), context.constants.cart.summaryDescription ? renderProductSummary(product) : /*#__PURE__*/ React.createElement(ProductDescription, {
        className: "cart-product-description"
    }, product.description))), context.constants.cart.enableQuantity ? /*#__PURE__*/ React.createElement(ProductQuantityWrapper, null, /*#__PURE__*/ React.createElement(UpdateCartQuantity, {
        canBeClicked: (product.quantity || 0) >= 5,
        onClick: function() {
            return context.actions.updateQuantityInCartProduct(product.id, CartProductActionType.Add);
        }
    }, /*#__PURE__*/ React.createElement(FaArrowCircleUp, null)), /*#__PURE__*/ React.createElement(ProductQuantity, null, "Quantity: ", product.quantity), /*#__PURE__*/ React.createElement(UpdateCartQuantity, {
        canBeClicked: product.quantity === 0,
        onClick: function() {
            return context.actions.updateQuantityInCartProduct(product.id, CartProductActionType.Remove);
        }
    }, /*#__PURE__*/ React.createElement(FaArrowCircleDown, null))) : null);
};
var finalExport = withContext(CartProduct);
export default finalExport;
